import { Table } from 'components/core-ui/Table'
import { useNotification } from 'hooks'
import { useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { getColumns } from './helpers'
import { makeCoreGetRequest } from 'utils/api'
import { toTableGETUrl } from 'components/core-ui/Table/serializers'
import { toTableRowItems } from './serializers'
import { formatErrorMessage } from 'utils/formatting'
import s from '../../partners.modules.scss'
import { ViewActionIcon } from 'icons'

const StoresTable = props => {
  const { legalEntityId } = props

  // TODO define interfaces for table items
  const [tableItems, setTableItems] = useState<any[]>([])
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [totalCount, setTotalCount] = useState<number>(0)
  const [shouldRefreshData, setShouldRefreshData] = useState<boolean>(false)
  const [shouldResetPage, setShouldResetPage] = useState<boolean>(false)

  const { showNotification } = useNotification()

  const navigate = useNavigate()

  const columns = useMemo(() => getColumns(), [])

  const fetchData = async ({ page, rowsPerPage, order, orderBy, tableFilters, searchText }) => {
    setIsLoading(true)
    try {
      const response = await makeCoreGetRequest(
        toTableGETUrl({
          url: '/iam/external-partners/stores',
          page,
          rowsPerPage,
          order,
          orderBy,
          tableFilters: [{ name: 'legalEntity.id', value: legalEntityId }]
        })
      )

      setTableItems(toTableRowItems(response.list || []))
      setTotalCount(response.page.totalCount)
      setIsLoading(false)
    } catch (error) {
      showNotification({
        message: `There was an error fetching stores. ${formatErrorMessage(error)}`,
        type: 'error'
      })
    }
  }

  return (
    <Table
      hideCheckbox
      // orderBy="createdDate"
      // order="desc"
      title="Stores"
      columns={columns}
      items={tableItems}
      fetchData={fetchData}
      isLoading={isLoading}
      totalCount={totalCount}
      shouldRefreshData={shouldRefreshData}
      setShouldRefreshData={setShouldRefreshData}
      shouldResetPage={shouldResetPage}
      setShouldResetPage={setShouldResetPage}
      rowActions={[
        {
          label: 'Details',
          labelColor: 'white',
          typographyVariant: 'medium',
          backgroundColor: '#0970E6',
          desktopIcon: <ViewActionIcon />,
          onClick: (_e: React.MouseEvent<HTMLElement>, rowId: number) =>
            navigate(`/iam/externalPartners/stores/${rowId}`)
        }
      ]}
      rowActionsWidth="80px"
      desktopRowActionsWidth="100px"
    />
  )
}

export default StoresTable
